import { useT } from '../../i18n';
import { TimelineTaches } from './TimelineTaches';

// [Proposition: timeline-taches] Tab on the proposals page: the same view as
// Tâches → Planification des tâches, so the proposal can be reviewed in place.
export function TimelineProposal() {
  const { t } = useT();
  return (
    <>
      <p className="text-sm text-ink-3 mb-16">{t('tlt.where')}</p>
      <TimelineTaches />
    </>
  );
}
